import React, { useState, useContext } from 'react';
import { Dimmer, Loader, Button, Dropdown, Icon, Input, Select, Divider, Form, Modal } from 'semantic-ui-react';
import DailyActivityForm from './dailyActivityForm';

const DailyActivity = ({ activity, updateHandler, deleteHandler }) => {
    // const {menuItem}   = props;
    const { category, text, startTime, _id } = activity;
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deleteActivity, setDeleteActivity] = useState(false);

    const updateActivity = async (activity) => {
        setLoading(true);
        await updateHandler(activity);
        setEditMode(false);
        setLoading(false);
    };

    const deleteActivityItem = async () => {
        setLoading(true);
        await deleteHandler(_id);
        setDeleteActivity(false);
        setLoading(false);
    };
    //confirmation for the delete action
    //show time of the activity

    return (
        <div className="menu-item daily-activity" key={_id}>
            <Modal open={deleteActivity} onClose={() => setDeleteActivity(false)} size="tiny" closeIcon>
                <Modal.Content>
                    <Dimmer active={loading} inverted>
                        <Loader active={loading} />
                    </Dimmer>
                    <p>Are you sure you want to delete Activity?</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={deleteActivityItem} color="red">
                        Delete
                    </Button>
                </Modal.Actions>
            </Modal>

            {!editMode ? (
                <>
                    <div className="content">
                        <div className="title">{text}</div>
                        <div className="time">
                            {new Date(startTime).toDateString()}{' '}
                            {new Date(startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </div>
                    </div>
                    <div>
                        <Dropdown icon="ellipsis vertical">
                            <Dropdown.Menu className="left">
                                <Dropdown.Item
                                    onClick={() => {
                                        setEditMode(true);
                                    }}
                                >
                                    Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        setDeleteActivity(true);
                                    }}
                                >
                                    Delete
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            ) : (
                <DailyActivityForm
                    activity={activity}
                    saveHandler={updateActivity}
                    cancelHandler={() => {
                        setEditMode(false);
                    }}
                />
            )}
        </div>
    );
};
export default DailyActivity;
